@if (meetingMenu?.length) {
    <adapt-menu [items]="meetingMenu"
                data-tour="meeting-actions-button"
                data-test="meeting-actions-button"></adapt-menu>
}
